<div class="navigation-items action-items navigation-border-right">
  <div class="action-icon" (click)="triggerAction('addRowUR')">
    <svg-icon src='./assets/icons/addStep.svg' title="{{'approvalStatus.addRow' | translate | uppercase}}"
              class="menu-action-icon svg-icon-gray"></svg-icon>
    <div class="icon-label" [innerHTML]="'approvalStatus.addRow' | translate | uppercase"></div>
  </div>
  <div class="action-icon" (click)="triggerAction('removeRowUR')">
    <svg-icon src='./assets/icons/removeStep.svg' title="{{'approvalStatus.removeRow' | translate | uppercase}}"
              class="menu-action-icon svg-icon-gray"></svg-icon>
    <div class="icon-label" [innerHTML]="'approvalStatus.removeRow' | translate | uppercase"></div>
  </div>
</div>
<div class="navigation-items action-items">
  <div class="action-icon" (click)="triggerAction('cancelChangesUR')">
    <svg-icon src='./assets/icons/close-outline.svg' title="{{'approvalStatus.cancel' | translate | uppercase}}"
              class="menu-action-icon svg-icon-gray"></svg-icon>
    <div class="icon-label">{{'approvalStatus.cancel' | translate | uppercase}}</div>
  </div>
  <div class="action-icon" (click)="triggerAction('saveChangesUR')">
    <svg-icon src='./assets/icons/save.svg' title="SAVE"
              class="menu-action-icon svg-icon-gray"></svg-icon>
    <div class="icon-label">SAVE</div>
  </div>
  <div class="action-icon" (click)="triggerAction('addSignatureUR')">
    <svg-icon src='./assets/icons/addSignature.svg' title="{{'approvalStatus.addSignature' | translate | uppercase}}"
              class="menu-action-icon svg-icon-gray"></svg-icon>
    <div class="icon-label" [innerHTML]="'approvalStatus.addSignature' | translate | uppercase"></div>
  </div>
  <div class="action-icon" (click)="triggerAction('removeSignatureUR')">
    <svg-icon src='./assets/icons/removeSignature.svg' title="{{'approvalStatus.removeSignature' | translate | uppercase}}"
              class="menu-action-icon svg-icon-gray"></svg-icon>
    <div class="icon-label" [innerHTML]="'approvalStatus.removeSignature' | translate | uppercase"></div>
  </div>
</div>
